export default "__VITE_ASSET__90qhy9Bj__"